import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=9c034b32&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=9c034b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c034b32",
  null
  
)

export default component.exports